import {
  ASSIGNATED_ERRORS,
  CLEAN_STATE,
  GET_ASSIGNATED_INSURED,
  GET_ASSIGNATED_RESPONSABLE_INSURED,
  GET_ASSIGNATED_ZONES,
  GET_ASSIGNATED_ZONES_RESPONSABLE,
  GET_PRE_ASSIGNATED_RESPONSIBLE,
  POST_ASSIGNATED_RESPONSABLE,
  GET_NOTIFICA_SINIESTRO 
} from '../types'

const initialState = {
  cbInsured: [],
  cbZones: [],
  assignatdInsured: [],
  data: [],
  response: '',
  errors: [],
  loading: true,
  cbNotificaSiniestro: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSIGNATED_INSURED:
      return {
        ...state,
        cbInsured: action.payload,
        loading: false
      }
    case GET_ASSIGNATED_ZONES:
      return {
        ...state,
        cbZones: action.payload,
        loading: false
      }
    case GET_ASSIGNATED_RESPONSABLE_INSURED:
      return {
        ...state,
        assignatdInsured: action.payload,
        loading: false
      }
    case GET_ASSIGNATED_ZONES_RESPONSABLE:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case GET_PRE_ASSIGNATED_RESPONSIBLE:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case POST_ASSIGNATED_RESPONSABLE:
      return {
        ...state,
        response: action.payload,
        loading: false
      }
    case ASSIGNATED_ERRORS:
      return {
        ...state,
        erros: action.payload,
        loading: false
      }
    case CLEAN_STATE:
      return {
        ...state,
        cbInsured: [],
        cbZones: [],
        assignatdInsured: [],
        data: [],
        response: '',
        errors: [],
        loading: true
      }
    case GET_NOTIFICA_SINIESTRO:
      return {
        ...state,
        cbNotificaSiniestro: action.payload,
        loading: false
      }

    default:
      return state
  }
}
